import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Sidebar = () => {
  console.log("✅ Sidebar component rendering...");

  const navigate = useNavigate();

  const handleLinkClick = (label) => {
    console.log(`👉 Sidebar link clicked: ${label}`);
  };

  const handleLogout = () => {
    console.log("🚪 Employee logout button clicked");
    localStorage.removeItem("employeeToken");
    console.log("🧹 Cleared local storage token");
    navigate("/login");
    console.log("🔀 Redirected to login page");
  };

  // Database section
  const databaseLinks = [
    { path: "/freelancer-email-verification", label: "Freelancer Email Verification" },
    { path: "/freelancer-basic-info", label: "Freelancer Basic Info" },
    { path: "/freelancer-preferences", label: "Freelancer Preferences" },
    { path: "/freelancer-subscription-info", label: "Freelancer Subscription Info" },
    { path: "/freelancer-subscription-info-history", label: "Freelancer Subscription History" },
    { path: "/freelancer-account-info", label: "Freelancer Account Info" },
    { path: "/freelancer-account-status-history", label: "Freelancer Account Status History" },
    { path: "/orders", label: "Orders" },
    { path: "/freelancer-payout-summary", label: "Freelancer Payout Summary" },
    { path: "/freelancer-payout-transactions", label: "Freelancer Payout Transactions" },
    { path: "/freelancer-withdrawal-bank-details", label: "Freelancer Withdrawal Bank Details" },
    { path: "/evaluation-tracker", label: "Evaluation Tracker" },
    { path: "/employees", label: "Employees" },
    { path: "/beginner-mcqs", label: "Beginner MCQs" },
    { path: "/support-tickets", label: "Support Tickets" },
    { path: "/task-info", label: "Task Info" },
    { path: "/clients", label: "Clients" },
    { path: "/freelancer-bank-change-logs", label: "Freelancer Bank Change Logs" },
    { path: "/freelancer-complete-info", label: "Freelancer Complete Info" },
  ];

  // Admin section
  const adminLinks = [
    { path: "/create-new-employee", label: "Create New Employee" },
    { path: "/block-freelancer", label: "Block/Unblock Freelancer" },
  ];

  // CEO section
  const ceoLinks = [
    { path: "/subscriptions-and-payouts", label: "Subscription numbers" },
    { path: "/freelancer-order-data", label: "Freelancers Vs Orders" },
    { path: "/freelancer-earning-data", label: "Freelancers Vs Earnings" },
    { path: "/daily-report-numbers", label: "Daily Report Numbers" },
    { path: "/daily-report-chart", label: "Daily Report Chart V1" },
    { path: "/daily-report-chart-v2", label: "Daily Report Chart V2" },
  ];

  // Book-keeper section
  const bookKeeperLinks = [
    { path: "/bk-freelancer-payin", label: "BK Freelancer Pay In" },
    { path: "/bk-freelancer-payout", label: "BK Freelancer Pay Out" },
  ];

  const renderSection = (title, links, colorClass = "hover:bg-purple-700") => (
    <div className="mb-6">
      <h2 className="text-lg font-semibold mb-2 border-b border-gray-600 pb-1">{title}</h2>
      <ul>
        {links.map(({ path, label }) => (
          <li key={path}>
            <Link
              to={path}
              onClick={() => handleLinkClick(label)}
              className={`block py-2 px-3 rounded ${colorClass}`}
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="fixed top-0 left-0 w-[18rem] h-screen bg-black text-white p-6 overflow-y-auto z-50">
      <h1 className="text-2xl font-bold mb-6">Admin Panel</h1>

      {renderSection("Database", databaseLinks)}
      {renderSection("Admin", adminLinks, "hover:bg-green-700")}
      {renderSection("CEO", ceoLinks, "hover:bg-yellow-600")}
      {renderSection("Book-Keeper", bookKeeperLinks, "hover:bg-green-800")}

      {/* Logout button */}
      <button
        onClick={handleLogout}
        className="mt-6 w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded"
      >
        Logout
      </button>
    </div>
  );
};

export default Sidebar;
